// extracted by mini-css-extract-plugin
export default {"search":"Search_search__FNlO6"};